import React from 'react';
import { httpServices }  from '../../../services/httpServices';
import {SyncMappingReportComponent} from './SyncMappingReportComponent';
import * as _ts from '../../common/treeSelect';
import { ErrorPage } from '../../common/error';
const reportFields = {
    'dest_instance' : '-1',
    'included_src_staff' : [0],
    'sync_status' : 1,
    'included_src_staff_ids': [0],
    'included_staff': [] 
}

const formInputs = {
    'dest_instance' : ['-1'], 
    'src_staff_list' : {},
}
export class SyncMappingReportContainer extends React.Component{
    constructor(props) {
        super(props);
        this.state =
        {
            destinationInstanceList : [],
            formInputs : formInputs,
            errors: {},
            snackbarOpen : false,
            snackbarMsg : '',
            snackbarVariant : '',
            srcUserList :[],
            destUserList : [],
            src_users : [],
            reportFields: reportFields,
            permission: false,
        }
        this.snackbarClose = this.snackbarClose.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleSourceUserChange = this.handleSourceUserChange.bind(this);
    }

    componentDidMount() {
        this.getSyncReport();
    }
   
    getSyncReport = () => {
        let formInputs = this.state.formInputs;

        httpServices.post('api/report/syncMappingReport', {'dest_instance' :formInputs.dest_instance, 'src_staff': formInputs.src_staff, 'sync_status' : formInputs.sync_status })
            .then(response => {
                if(response.data.permission) {
                    let src_staff_list = response.data.source_user_list;
                    let ff = this.state.reportFields;
                    let repInputs = this.state.formInputs;
                    repInputs['src_staff_list'] = src_staff_list;
                    ff['included_src_staff'] = [src_staff_list[0]];
                    this.setState({
                        destinationInstanceList : response.data.sync_instance_names,
                        formInputs : repInputs,
                        reportFields : ff,   
                        permission: response.data.permission                 
                    });
                }
                else {
                    this.setState({
                        permission: response.data.permission
                    });
                }
           })
    } 

    handleValidation = () => {
        let formIsValid = true;
        let errors = {};
        if (!this.state.formInputs.dest_instance ) {
            errors["dest_instance"] = "Cannot be empty";
            formIsValid = false;
        }
        if (!this.state.formInputs.src_staff) {
            errors["src_staff"] = "Cannot be empty";
            formIsValid = false;
        }
        if (this.state.formInputs.sync_status === -1) {
            errors["sync_status"] = "Cannot be empty";
            formIsValid = false;
        }
        this.setState({errors: errors});
        return formIsValid;
    }
    
     handleOnChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.reportFields;
        ff[field] = evt.target.value;
        this.setState({
            reportFields: ff
        });
    }
    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }

    handleSourceUserChange = (evt,value) => {
        let ff = this.state.formInputs;
        console.log(ff);
        let included_staff = [];
        let new_value = [];
        if (value) {
             let isAllinList = value.findIndex(i => i.first_name === "All Users");
            if (isAllinList !== -1 && isAllinList === value.length-1) { 
                new_value = [ff.src_staff_list[0]];
                included_staff.push(0);
            } else {
                value.forEach(function(item) { 
                    if (item.first_name !== "All Users") {
                        new_value.push(item);
                        included_staff.push(parseInt(item.user_id));
                    }
                })
            }
            if (value.length == 0) {
                new_value = [ff.src_staff_list[0]];
            }
            ff['included_src_staff'] = new_value;
            ff['included_staff'] = included_staff;
        }
        
        this.setState({
            reportFields: ff
        });
    };
    render(){
        return(
            <>
            {(this.state.permission) ?
            <SyncMappingReportComponent 
                DestinationInstanceList = { this.state.destinationInstanceList }
                FormInputs = {this.state.formInputs}
                HandleOnChange = {this.handleOnChange}
                Errors = {this.state.errors}
                SnackbarOpen = {this.state.snackbarOpen}
                SnackbarMsg = {this.state.snackbarMsg}
                SnackbarVariant = {this.state.snackbarVariant}
                SnackbarClose = {this.snackbarClose}       
                SourceUserList = { this.state.srcUserList}
                handleSourceUserChange = {this.handleSourceUserChange}
                ReportFields = {this.state.reportFields}
            />
           :
           <ErrorPage/>
            }
        </>  
    )}
}
